import { render, staticRenderFns } from "./Warboard.vue?vue&type=template&id=c9b4cf90&scoped=true&"
import script from "./Warboard.vue?vue&type=script&lang=js&"
export * from "./Warboard.vue?vue&type=script&lang=js&"
import style0 from "./Warboard.vue?vue&type=style&index=0&id=c9b4cf90&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9b4cf90",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c9b4cf90')) {
      api.createRecord('c9b4cf90', component.options)
    } else {
      api.reload('c9b4cf90', component.options)
    }
    module.hot.accept("./Warboard.vue?vue&type=template&id=c9b4cf90&scoped=true&", function () {
      api.rerender('c9b4cf90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Warboard.vue"
export default component.exports